import { registerResize, clearResize } from "../../helpers/resizeHandler";
import { debouncePerKey } from "../../helpers/utils";
export default {
  methods: {
    // note: in specific view, setup watchers that call resetView
    resetView: debouncePerKey(function(){this.updateCanvasSizes();}, 50, false, 0),
    // note: in specific view, override updateSizes
    updateCanvasSizes(){ }
  },
  mounted() { 
    registerResize(this);
  },
  beforeDestroy() { 
    clearResize(this);
  }
};